/**
 * common.ts
 * ----------------
 * Commonly used reducer implementations.
 */

import { AsyncAction } from '../../actions/types';
import { Status } from '../../constants/statuses';

/**
 * Creates a reducer that handles async actions in a standard way.
 * @param errorReducer Sub-reducer for transforming error in state
 * @param statusReducer Sub-reducer for transforming status in state
 * @returns Reducer for an async action
 */
export function asyncRequestReducer<TState> (
    errorReducer: (state: TState, error: string) => TState,
    statusReducer: (state: TState, status: Status) => TState) {
    return (state: TState, action: AsyncAction) => {
        const { error, status } = action;

        let nextState = statusReducer(state, status);

        if (status === 'failed') {
            if (error === undefined) {
                throw new Error(`Errors must be given if ${action.type} is dispatched with ${status} status.`);
            }

            nextState = errorReducer(nextState, error as string);
        } else {
            nextState = errorReducer(nextState, '');
        }

        return nextState;
    };
}
